/**
 * Copyright (C) 2024-present Puter Technologies Inc.
 *
 * This file is part of Puter.
 *
 * Puter is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

const ur = {
  name: "اردو",
  english_name: "Urdu",
  code: "ur",
  dictionary: {
    about: "بارے میں",
    account: "اکاؤنٹ",
    account_password: "اکاؤنٹ پاس ورڈ کی تصدیق کریں",
    access_granted_to: "رسائی مسموح ہے",
    add_existing_account: "موجودہ اکاؤنٹ شامل کریں",
    all_fields_required: "تمام شعبوں کی ضرورت ہے",
    apply: "لگائیں ",
    ascending: "بڑھتی ہوئی",
    auto_arrange: "خودکار ترتیب",
    background: "پس منظر",
    browse: "تلاش کریں",
    cancel: "منسوخ کریں",
    center: "مرکز",
    change_desktop_background: "ڈیسک ٹاپ کا پس منظر تبدیل کریں",
    change_email: "ای میل تبدیل کریں",
    change_language: "زبان تبدیل کریں",
    change_password: "پاس ورڈ تبدیل کریں",
    change_ui_colors: "یوزر انٹرفیس کے رنگ تبدیل کریں۔",
    change_username: "صارف کا نام تبدیل کریں",
    close: "بند کریں",
    close_all_windows: "تمام ونڈوز بند کریں",
    close_all_windows_confirm: "کیا آپ واقعی تمام ونڈوز بند کرنا چاہتے ہیں؟",
    close_all_windows_and_log_out: "ونڈوز بند کریں اور لاگ آؤٹ کریں۔",
    change_always_open_with: "کیا آپ ہمیشہ اس قسم کی فائل کو کھولنا چاہتے ہیں۔",
    color: "رنگ",
    confirm_2fa_setup: "میں نے کوڈ کو اپنی تصدیق کنندہ ایپ میں شامل کر دیا ہے۔",
    confirm_2fa_recovery:
      "میں نے اپنے ریکوری کوڈز کو محفوظ جگہ پر محفوظ کر لیا ہے۔",
    confirm_account_for_free_referral_storage_c2a:
      "1 GB مفت اسٹوریج حاصل کرنے کے لیے ایک اکاؤنٹ بنائیں اور اپنے ای میل ایڈریس کی تصدیق کریں۔ آپ کے دوست کو 1 GB مفت اسٹوریج بھی ملے گا۔",
    confirm_code_generic_incorrect: "غلط کوڈ۔",
    confirm_code_generic_too_many_requests:
      "بہت زیادہ درخواستیں براہ کرم چند منٹ انتظار کریں۔",
    confirm_code_generic_submit: "کوڈ جمع کروائیں۔",
    confirm_code_generic_try_again: "دوبارہ کوشش کریں",
    confirm_code_generic_title: "تصدیقی کوڈ درج کریں",
    confirm_code_2fa_instruction:
      "اپنی تصدیق کنندہ ایپ سے 6 ہندسوں کا کوڈ درج کریں۔",
    confirm_code_2fa_submit_btn: "جمع کرائیں",
    confirm_code_2fa_title: "2FA کوڈ درج کریں۔",
    confirm_delete_multiple_items:
      "کیا آپ واقعی ان آئٹمز کو مستقل طور پر حذف کرنا چاہتے ہیں؟",
    confirm_delete_single_item:
      "کیا آپ اس آئٹم کو مستقل طور پر حذف کرنا چاہتے ہیں؟",
    confirm_open_apps_log_out:
      "آپ کے پاس کھلی ایپس ہیں۔ کیا آپ واقعی لاگ آؤٹ کرنا چاہتے ہیں؟",
    confirm_new_password: "نئے پاس ورڈ کی توثیق کریں",
    confirm_delete_user:
      "کیا آپ واقعی اپنا اکاؤنٹ حذف کرنا چاہتے ہیں؟ آپ کی تمام فائلیں اور ڈیٹا مستقل طور پر حذف ہو جائیں گے۔ اس کارروائی کو کالعدم نہیں کیا جا سکتا۔",
    confirm_delete_user_title: "اکاؤنٹ حذف کرنا ہے؟",
    confirm_session_revoke: "کیا آپ واقعی اس سیشن کو منسوخ کرنا چاہتے ہیں؟",
    contact_us: "ہم سے رابطہ کریں",
    contact_us_verification_required:
      "اسے استعمال کرنے کے لیے آپ کے پاس تصدیق شدہ ای میل پتہ ہونا ضروری ہے۔",
    contain: "شامل کریں",
    continue: "جاری رہے",
    copy: "کاپی کریں",
    copy_link: "لنک کاپی کریں",
    copying: "کاپی کر رہا ہے",
    copying_file: "%% کاپی کر رہا ہے",
    cover: "احاطہ",
    create_account: "اکاؤنٹ بنائیں",
    create_free_account: "مفت اکاؤنٹ بنائیں",
    create_shortcut: "شارٹ کٹ تخلیق کریں",
    credits: "کریڈٹس",
    current_password: "موجودہ پاس ورڈ",
    cut: "کاٹیں",
    clock: "گھڑی",
    clock_visible_hide: "چھپائیں - ہمیشہ پوشیدہ",
    clock_visible_show: "دکھائیں - ہمیشہ دکھائی دیں۔",
    clock_visible_auto:
      "خودکار - پہلے سے طے شدہ، صرف فل سکرین موڈ میں نظر آتا ہے۔",
    date_modified: "تاریخ تبدیل",
    default: "پہلے سے طے شدہ",
    delete: "حذف کریں",
    delete_account: "اکاؤنٹ حذف کریں",
    delete_permanently: "مستقل حذف کریں",
    deleting_file: "حذف ہو رہا %% ",
    deploy_as_app: "ایپ کے طور پر منتشر کریں",
    descending: "گرتی ہوئی",
    desktop: "ڈیسک ٹاپ",
    desktop_background_fit: "ڈیسک ٹاپ کا پس منظر مناسب ہو",
    developers: "ڈویلپرز",
    dir_published_as_website: "ڈائریکٹری کو ویب سائٹ کے طور پر شائع کیا گیا",
    disable_2fa: "2FA کو غیر فعال کریں۔",
    disable_2fa_confirm: "کیا آپ واقعی 2FA کو غیر فعال کرنا چاہتے ہیں؟",
    disable_2fa_instructions:
      "2FA کو غیر فعال کرنے کے لیے اپنا پاس ورڈ درج کریں۔",
    disassociate_dir: "ڈائرکٹری کو الگ کریں۔",
    documents: "دستاویزات",
    download: "ڈاؤن لوڈ کریں ",
    download_file: "فائل ڈاؤن لوڈ کریں",
    downloading: "ڈاؤن لوڈ ہو رہا ہے ",
    email: "ای میل",
    email_change_confirmation_sent:
      "ایک تصدیقی ای میل آپ کے نئے ای میل پتے پر بھیج دیا گیا ہے۔ براہ کرم اپنا ان باکس چیک کریں اور عمل کو مکمل کرنے کے لیے ہدایات پر عمل کریں۔",
    email_invalid: "ای میل غلط ہے۔",
    email_or_username: "ای میل یا صارف کا نام ",
    email_required: "ای میل درکار ہے۔",
    empty_trash: "کچرا خالی کریں",
    empty_trash_confirmation: "کچرا خالی کرنے کی تصدیق ",
    emptying_trash: "کچرا خالی ہو رہا ہے",
    enable_2fa: "2FA کو فعال کریں۔",
    end_hard: "ہارڈ کو ختم کریں۔",
    end_process_force_confirm:
      "کیا آپ واقعی اس عمل کو زبردستی چھوڑنا چاہتے ہیں؟",
    end_soft: "اینڈ نرم",
    enlarged_qr_code: "بڑھا ہوا QR کوڈ",
    enter_password_to_confirm_delete_user:
      "اکاؤنٹ حذف کرنے کی تصدیق کے لیے اپنا پاس ورڈ درج کریں۔",
    error_unknown_cause: "ایک نامعلوم خرابی پیش آگئی۔",
    error_uploading_files: "فائلیں اپ لوڈ کرنے میں ناکام",
    favorites: "پسندیدہ",
    feedback: "رائے ",
    feedback_c2a: " رائے ",
    feedback_sent_confirmation: "تبادلہ رائے بھیجے جانے کی تصدیق ",
    fit: "فٹ",
    force_quit: "زبردستی چھوڑیں۔",
    forgot_pass_c2a: "پاس ورڈ بھول گئے ہیں؟",
    from: "سے",
    general: "عام ",
    get_a_copy_of_on_puter: "Puter.com پر '%%' کی ایک کاپی حاصل کریں!",
    get_copy_link: "کاپی لنک حاصل کریں",
    hide_all_windows: "تمام ونڈوز چھپائیں ",
    home: "گھر",
    html_document: "ایچ ٹی ایم ایل دستاویز",
    hue: "رنگت",
    image: "تصویر",
    incorrect_password: "غلط پاس ورڈ",
    invite_link: "دعوتی لنک",
    item: "آئٹم",
    items_in_trash_cannot_be_renamed:
      "کچرے میں موجود اشیاء کا نام تبدیل نہیں کیا جا سکتا",
    jpeg_image: "جے پی ای جی_تصویر",
    keep_in_taskbar: "ٹاسک بار میں رکھیں ",
    language: "زبان",
    license: "License",
    lightness: "لائسنس",
    link_copied: "لنک کاپی ہو گیا۔",
    loading: "لوڈ ہو رہا ہے۔",
    log_in: "لاگ ان کریں",
    log_into_another_account_anyway: "بہر حال دوسرے اکاؤنٹ میں لاگ ان کریں۔",
    log_out: "لاگ آؤٹ",
    looks_good: "اچھا لگ رہا ہے!",
    manage_sessions: "سیشنز کا نظم کریں۔",
    move: "منتقل کریں",
    moving_file: "منتقل ہو رہا ہے %%",
    my_websites: "میری ویب سائٹیں ",
    name: "نام",
    name_cannot_be_empty: "نام خالی نہیں ہو سکتا",
    name_cannot_contain_double_period: "نام میں ڈبل پرانا نہیں ہو سکتا ",
    name_cannot_contain_period: "نام میں نقطہ نہیں ہو سکتا",
    name_cannot_contain_slash: "نام میں سلیش نہیں ہو سکتا",
    name_must_be_string: "نام کا سٹرنگ ہونا لازمی ہے",
    name_too_long: "نام بہت لمبا ہے",
    new: "نیا",
    new_email: "نیا ای میل",
    new_folder: "نیا فولڈر ",
    new_password: "نیا پاس ورڈ ",
    new_username: "نیا صارف کا نام ",
    no: "نہیں",
    no_dir_associated_with_site: "کوئی ڈائریکٹری سائٹ سے منسلک نہیں ہے",
    no_websites_published: "کوئی ویب سائٹیں شائع نہیں ہوئیں",
    ok: "ٹھیک ہے",
    open: "کھولیں",
    open_in_new_tab: "نئی ٹیب میں کھولیں",
    open_in_new_window: "نئی ونڈو میں کھولیں ",
    open_with: "کے ساتھ کھولیں ",
    oss_code_and_content: "اوپن سورس سافٹ ویئر اور مواد",
    password: "پاس ورڈ ",
    password_changed: "پاس ورڈ تبدیل ہوگیا ",
    password_recovery_rate_limit:
      "آپ ہماری شرح کی حد تک پہنچ گئے ہیں؛ براہ کرم چند منٹ انتظار کریں۔ مستقبل میں اسے روکنے کے لیے، صفحہ کو کئی بار دوبارہ لوڈ کرنے سے گریز کریں۔",
    password_recovery_token_invalid: "یہ پاس ورڈ بازیافت ٹوکن اب درست نہیں ہے۔",
    password_recovery_unknown_error:
      "ایک نامعلوم خرابی پیش آگئی۔ براہ کرم کچھ دیر بعد کوشش کریں۔",
    password_required: "پاس ورڈ درکار ہے۔",
    password_strength_error:
      "پاس ورڈ کم از کم 8 حروف کا ہونا چاہیے اور اس میں کم از کم ایک بڑے حروف، ایک چھوٹے حروف، ایک عدد، اور ایک خاص حرف ہونا چاہیے۔",
    passwords_do_not_match: "پاس ورڈ میچ نہیں ہوتی",
    paste: "چسپاں کریں",
    paste_into_folder: "فولڈر میں چسپاں کریں",
    personalization: "متشکل",
    pick_name_for_website: "ویب سائٹ کے لئے نام منتخب کریں ",
    picture: "تصویر ",
    pictures: "تصویریں",
    plural_suffix: "س",
    powered_by_puter_js:
      "پیوٹر جے ایس کے زریعے محرک{{link=docs}}Puter.js{{/link}}",
    preparing: "تیاری ",
    preparing_for_upload: "اپلوڈ کے لئے تیاری ",
    print: "پرنٹ کریں",
    privacy: "رازداری",
    proceed_to_login: "لاگ ان کرنے کے لیے آگے بڑھیں۔",
    proceed_with_account_deletion: "اکاؤنٹ حذف کرنے کے ساتھ آگے بڑھیں۔",
    process_status_initializing: "شروع کر رہا ہے۔",
    process_status_running: "چل رہا ہے۔",
    process_type_app: "ایپ",
    process_type_init: "اس میں",
    process_type_ui: "UI",
    properties: "خصوصیات ",
    public: "عوام",
    publish: "شائع کریں",
    publish_as_website: "ویب سائٹ کے طور پر شائع کریں",
    puter_description: `Puter ایک رازداری کا پہلا ذاتی کلاؤڈ ہے جو آپ کی تمام فائلوں، ایپس اور گیمز کو ایک محفوظ جگہ پر رکھتا ہے، کسی بھی وقت کہیں سے بھی قابل رسائی ہے۔`,
    reading_file: "پڑھنا %strong%",
    recent: "حال ہی میں",
    recommended: "تجویز کردہ",
    recover_password: "پاس ورڈ بازیاب کریں ",
    refer_friends_c2a:
      "! ہر دوست کے اکاؤنٹ بنانے اور اکاؤنٹ کی تصدیق کرنے پر 1 گیگابائٹ حاصل کریں۔ آپ کا دوست بھی 1 گیگابائٹ حاصل کرے گا ",
    refer_friends_social_media_c2a:
      "پیوٹر ڈاٹ کام پر مفت 1 گیگابائٹ ذخیرہ حاصل کریں!",
    refresh: "تازہ کریں ",
    release_address_confirmation: "ایڈریس کی تصدیق جاری ",
    remove_from_taskbar: "ٹاسک بار سے ہٹائیں ",
    rename: "دوبارہ نام دیں",
    repeat: "دہرایؐں",
    replace: "بدل دیں۔",
    replace_all: "سبھی کو تبدیل کریں۔",
    resend_confirmation_code: "تصدیقی کوڈ دوبارہ بھیجیں",
    reset_colors: "رنگوں کو دوبارہ ترتیب دیں۔",
    restart_puter_confirm: "کیا آپ واقعی Puter کو دوبارہ شروع کرنا چاہتے ہیں؟",
    restore: "بحال کریں",
    saturation: "سنترپتی",
    save_account: "اکاؤنٹ محفوظ کریں۔",
    save_account_to_get_copy_link:
      "کاپی لنک حاصل کرنے کے لئے اکاؤنٹ محفوظ کریں",
    save_account_to_publish: "شائع کرنے کے لئے اکاؤنٹ محفوظ کریں",
    save_session: "سیشن محفوظ کریں۔",
    save_session_c2a: "سیشن کو محفوظ کریں ",
    scan_qr_c2a:
      "!دیے گئے کوڈ کو اسکین کریں! تاکہ دوسری ڈیواسؐز سے اس سیشن میں لاگ ان کیا جا سکے",
    scan_qr_2fa: "اپنی تصدیق کنندہ ایپ سے QR کوڈ اسکین کریں۔",
    scan_qr_generic:
      "اس QR کوڈ کو اپنے فون یا کسی دوسرے آلے کا استعمال کرکے اسکین کریں۔",
    search: "تلاش کریں۔",
    seconds: "سیکنڈ",
    security: "سیکورٹی",
    select: "منتخب کریں",
    selected: "منتخب شدہ",
    select_color: "رنگ منتخب کریں",
    send: "بھیجیں",
    send_password_recovery_email: "پاس ورڈ بحالی ای میل بھیجیں",
    session_saved: "سیشن محفوظ ہوگیا ہے ",
    settings: "ترتیبات",
    set_new_password: "نیا پاس ورڈ مقرر کریں ",
    share_to: " کے ساتھ شیئر کریں",
    show_all_windows: "تمام ونڈوز دکھائیں ",
    show_hidden: "پوشیدہ دکھائیں ",
    sign_in_with_puter: "پیوٹر کے ساتھ سائن ان کریں",
    sign_up: "سائن اپ کریں",
    signing_in: "لاگ ان کر رہے ہیں",
    size: "سائز",
    skip: "چھوڑ دو",
    something_went_wrong: "کچھ غلط ہو گیا۔",
    sort_by: " ترتیب دیں",
    start: "شروع کریں ",
    status: "حالت",
    storage_usage: "اسٹوریج کا استعمال",
    storage_puter_used: "Puter کی طرف سے استعمال کیا جاتا ہے",
    taking_longer_than_usual: "عام طور پر سے زیادہ وقت لگ رہا ہے ",
    task_manager: "ٹاسک مینیجر",
    taskmgr_header_name: "نام",
    taskmgr_header_status: "حالت",
    taskmgr_header_type: "قسم",
    terms: "شرائط",
    text_document: "متن دستاویز",
    tos_fineprint: `براہ کرم "مفت اکاؤنٹ بنائیں" پر کلک کرکے `,
    transparency: "شفافیت",
    trash: "کچرا",
    two_factor: "دو عنصر کی تصدیق",
    two_factor_disabled: "2FA غیر فعال",
    two_factor_enabled: "2FA فعال",
    type: "لکہنا",
    type_confirm_to_delete_account:
      "اپنا اکاؤنٹ حذف کرنے کے لیے 'تصدیق' ٹائپ کریں۔",
    ui_colors: "UI رنگ",
    ui_manage_sessions: "سیشن مینیجر",
    ui_revoke: "منسوخ کرنا",
    undo: "واپسی کریں",
    unlimited: "لا محدود",
    unzip: "زپ کھولیں",
    upload: "اپ لوڈ کریں ",
    upload_here: "یہاں اپ لوڈ کریں",
    usage: "استعمال",
    username: "صارف کا نام ",
    username_changed: "صارف کا نام تبدیل ہوگیا",
    username_required: "صارف نام درکار ہے۔",
    versions: "ورژنز ",
    videos: "ویڈیوز",
    visibility: "مرئیت",
    yes: "جی ہاں",
    yes_release_it: "ہاں اسے جاری کریں",
    you_have_been_referred_to_puter_by_a_friend:
      "آپ کو ایک دوست نے پیوٹر کی جانب رجوع کیا ہے!",
    zip: "زپ فائل",
    zipping_file: "زپ %strong%",

    // === 2FA Setup ===
    // === 2FA سیٹ اپ ===

    setup2fa_1_step_heading: "اپنا تصدیق کنندہ ایپ کھولیں۔",
    setup2fa_1_instructions: `
       آپ کوئی بھی مستند ایپ استعمال کر سکتے ہیں جو ٹائم بیسڈ ون ٹائم پاس ورڈ (TOTP) پروٹوکول کو سپورٹ کرتی ہو۔
        منتخب کرنے کے لیے بہت سے ہیں، لیکن اگر آپ کو یقین نہیں ہے۔
        <a target="_blank" href="https://authy.com/download">Authy</a>
        Android اور iOS کے لیے ایک ٹھوس انتخاب ہے۔
    `,
    setup2fa_2_step_heading: "QR کوڈ اسکین کریں۔",
    setup2fa_3_step_heading: "6 ہندسوں کا کوڈ درج کریں۔",
    setup2fa_4_step_heading: "اپنے ریکوری کوڈز کاپی کریں۔",
    setup2fa_4_instructions: `
        یہ ریکوری کوڈز آپ کے اکاؤنٹ تک رسائی حاصل کرنے کا واحد طریقہ ہیں اگر آپ اپنا فون کھو دیتے ہیں یا آپ اپنا مستند ایپ استعمال نہیں کر پاتے ہیں۔
        ان کو محفوظ جگہ پر رکھنا یقینی بنائیں۔
    `,
    setup2fa_5_step_heading: "2FA سیٹ اپ کی تصدیق کریں۔",
    setup2fa_5_confirmation_1:
      "میں نے اپنے ریکوری کوڈز کو محفوظ جگہ پر محفوظ کر لیا ہے۔",
    setup2fa_5_confirmation_2: "میں 2FA کو فعال کرنے کے لیے تیار ہوں۔",
    setup2fa_5_button: "2FA کو فعال کریں۔",

    // === 2FA Login ===
    login2fa_otp_title: "2FA کوڈ درج کریں۔",
    login2fa_otp_instructions:
      "اپنی تصدیق کنندہ ایپ سے 6 ہندسوں کا کوڈ درج کریں۔",
    login2fa_recovery_title: "ایک ریکوری کوڈ درج کریں۔",
    login2fa_recovery_instructions:
      "اپنے اکاؤنٹ تک رسائی کے لیے اپنا ایک ریکوری کوڈ درج کریں۔",
    login2fa_use_recovery_code: "ریکوری کوڈ استعمال کریں۔",
    login2fa_recovery_back: "پیچھے",
    login2fa_recovery_placeholder: "XXXXXXXX",

    "allow": "اجازت دینا", // In English: "Allow"
    "associated_websites": "متعلقہ ویب سائٹس", // In English: "Associated Websites"
    "change": "تبدیل کرنا", // In English: "Change"
    "clock_visibility": "گھڑی کی نمائش", // In English: "Clock Visibility"
    "confirm": "تصدیق", // In English: "Confirm"
    "confirm_your_email_address": "اپنے ای میل ایڈریس کی تصدیق کریں", // In English: "Confirm Your Email Address"
    "close_all": "سب کو بند کریں", // In English: "Close All"
    "created": "بنائی", // In English: "Created"
    "dont_allow": "اجازت نہ دیں", // In English: "Don't Allow"
    "error_message_is_missing": "غلطی کا پیغام غائب ہے", // In English: "Error message is missing."
    "folder": "فولڈر", // In English: "Folder"
    "modified": "ترمیم", // In English: "Modified"
    "original_name": "اصل نام", // In English: "Original Name"
    "original_path": "اصل راستہ", // In English: "Original Path"
    "path": "راستہ", // In English: "Path"
    "reading": "پڑھنا %strong%", // In English: "Reading %strong%"
    "writing": "لکھنا %strong%", // In English: "Writing %strong%"
    "save": "محفوظ کریں", // In English: "Save"
    "sessions": "سیشنز", // In English: "Sessions"
    "share": "شیئر کریں", // In English: "Share"
    "share_with": "شیئر کریں:", // In English: "Share with:"
    "shortcut_to": "شارٹ کٹ برائے", // In English: "Shortcut to"
    "unzipping": "اَن زپ کر رہا ہے %strong%", // In English: "Unzipping %strong%"
    "sequencing": "ترتیب دے رہا ہے %strong%", // In English: "Sequencing %strong%"
    "zipping": "زپ کر رہا ہے %strong%", // In English: "Zipping %strong%"
    "Editor": "ایڈیٹر", // In English: "Editor" - Some words in Urdu are written the same as in English, like "editor," and they don't have a specific Urdu equivalent that conveys the original meaning. These are common words that every native Urdu speaker understands.
    "Viewer": "دیکھنے والا", // In English: "Viewer"
    "People with access": "لوگ جنہیں رسائی حاصل ہے", // In English: "People with access"
    "Share With…": "...کے ساتھ شیئر کریں", // In English: "Share With…"
    "Owner": "مالک", // In English: "Owner"
    "You can't share with yourself.": "آپ خود کے ساتھ شیئر نہیں کر سکتے۔", // In English: "You can't share with yourself."
    "This user already has access to this item": "اس صارف کو پہلے ہی اس آئٹم تک رسائی حاصل ہے۔", // In English: "This user already has access to this item"

    "billing.change_payment_method": "ادائیگی کے طریقہ کو تبدیل کریں", // In English: "Change"
    "billing.cancel": "منسوخ کریں", // In English: "Cancel"
    "billing.download_invoice": "انوائس ڈاؤن لوڈ کریں", // In English: "Download"
    "billing.payment_method": "ادائیگی کا طریقہ", // In English: "Payment Method"
    "billing.payment_method_updated": "ادائیگی کا طریقہ اپ ڈیٹ کر دیا گیا ہے!", // In English: "Payment method updated!"
    "billing.confirm_payment_method": "ادائیگی کے طریقہ کی تصدیق کریں", // In English: "Confirm Payment Method"
    "billing.payment_history": "ادائیگی کی تاریخ", // In English: "Payment History"
    "billing.refunded": "رقم واپس کر دی گئی", // In English: "Refunded"
    "billing.paid": "ادائیگی ہو چکی ہے", // In English: "Paid"
    "billing.ok": "ٹھیک ہے", // In English: "OK"
    "billing.resume_subscription": "سبسکرپشن بحال کریں", // In English: "Resume Subscription"
    "billing.subscription_cancelled": "آپ کی سبسکرپشن منسوخ کر دی گئی ہے۔", // In English: "Your subscription has been canceled."
    "billing.subscription_cancelled_description": "آپ کو اس بلنگ مدت کے اختتام تک اپنی سبسکرپشن تک رسائی حاصل رہے گی۔", // In English: "You will still have access to your subscription until the end of this billing period."
    "billing.offering.free": "مفت", // In English: "Free"
    "billing.offering.pro": "پروفیشنل", // In English: "Professional"
    "billing.offering.professional": "پروفیشنل", // In English: "Professional"
    "billing.offering.business": "کاروبار", // In English: "Business"
    "billing.cloud_storage": "کلاؤڈ اسٹوریج", // In English: "Cloud Storage"
    "billing.ai_access": "اے آئی تک رسائی", // In English: "AI Access"
    "billing.bandwidth": "بینڈوتھ", // In English: "Bandwidth"
    "billing.apps_and_games": "ایپس اور گیمز", // In English: "Apps & Games"
    "billing.upgrade_to_pro": "پروفیشنل میں اپ گریڈ کریں", // In English: "Upgrade to %strong%"
    "billing.switch_to": "%strong% پر منتقل ہوں", // In English: "Switch to %strong%"
    "billing.payment_setup": "ادائیگی کی ترتیب", // In English: "Payment Setup"
    "billing.back": "پیچھے", // In English: "Back"
    "billing.you_are_now_subscribed_to": "آپ اب %strong% سطح کی سبسکرپشن کے حامل ہیں۔", // In English: "You are now subscribed to %strong% tier."
    "billing.you_are_now_subscribed_to_without_tier": "آپ اب سبسکرائب ہیں۔", // In English: "You are now subscribed"
    "billing.subscription_cancellation_confirmation": "کیا آپ واقعی اپنی سبسکرپشن منسوخ کرنا چاہتے ہیں؟", // In English: "Are you sure you want to cancel your subscription?"
    "billing.subscription_setup": "سبسکرپشن سیٹ اپ", // In English: "Subscription Setup"
    "billing.cancel_it": "اسے منسوخ کریں", // In English: "Cancel It"
    "billing.keep_it": "اسے رکھیں", // In English: "Keep It"
    "billing.subscription_resumed": "آپ کی %strong% سبسکرپشن دوبارہ شروع کر دی گئی ہے!", // In English: "Your %strong% subscription has been resumed!"
    "billing.upgrade_now": "اب اپ گریڈ کریں", // In English: "Upgrade Now"
    "billing.upgrade": "اپ گریڈ کریں", // In English: "Upgrade"
    "billing.currently_on_free_plan": "آپ اس وقت مفت پلان پر ہیں۔", // In English: "You are currently on the free plan."
    "billing.download_receipt": "رسیٹ ڈاؤن لوڈ کریں", // In English: "Download Receipt"
    "billing.subscription_check_error": "آپ کی سبسکرپشن کی حیثیت چیک کرتے وقت مسئلہ پیش آیا۔", // In English: "A problem occurred while checking your subscription status."
    "billing.email_confirmation_needed": "آپ کا ای میل تصدیق شدہ نہیں ہے۔ ہم اسے تصدیق کرنے کے لیے آپ کو ایک کوڈ بھیجیں گے۔", // In English: "Your email has not been confirmed. We'll send you a code to confirm it now."
    "billing.sub_cancelled_but_valid_until": "آپ نے اپنی سبسکرپشن منسوخ کر دی ہے اور یہ بلنگ پیریڈ کے آخر تک مفت پلان پر منتقل ہو جائے گی۔ آپ کو دوبارہ سبسکرائب کرنے تک دوبارہ چارج نہیں کیا جائے گا۔", // In English: "You have cancelled your subscription and it will automatically switch to the free tier at the end of the billing period. You will not be charged again unless you re-subscribe."
    "billing.current_plan_until_end_of_period": "آپ کا موجودہ پلان اس بلنگ پیریڈ کے آخر تک برقرار رہے گا۔", // In English: "Your current plan until the end of this billing period."
    "billing.current_plan": "موجودہ پلان", // In English: "Current plan"
    "billing.cancelled_subscription_tier": "منسوخ شدہ سبسکرپشن (%%)", // In English: "Cancelled Subscription (%%)"
    "billing.manage": "انتظام کریں", // In English: "Manage"
    "billing.limited": "محدود", // In English: "Limited"
    "billing.expanded": "وسیع", // In English: "Expanded"
    "billing.accelerated": "تیز رفتار", // In English: "Accelerated"
    "billing.enjoy_msg": "کلاؤڈ اسٹوریج کے %% حصے کے ساتھ دیگر فوائد کا لطف اٹھائیں۔", // In English: "Enjoy %% of Cloud Storage plus other benefits."

    // =============================================================
    // Missing translations
    // =============================================================
    "choose_publishing_option": undefined, // In English: "Choose how you want to publish your website:"
    "create_desktop_shortcut": undefined, // In English: "Create Shortcut (Desktop)"
    "create_desktop_shortcut_s": undefined, // In English: "Create Shortcuts (Desktop)"
    "create_shortcut_s": undefined, // In English: "Create Shortcuts"
    "minimize": undefined, // In English: "Minimize"
    "reload_app": undefined, // In English: "Reload App"
    "new_window": undefined, // In English: "New Window"
    "open_trash": undefined, // In English: "Open Trash"
    "pick_name_for_worker": undefined, // In English: "Pick a name for your worker:"
    "publish_as_serverless_worker": undefined, // In English: "Publish as Worker"
    "toolbar.enter_fullscreen": undefined, // In English: "Enter Full Screen"
    "toolbar.github": undefined, // In English: "GitHub"
    "toolbar.refer": undefined, // In English: "Refer"
    "toolbar.save_account": undefined, // In English: "Save Account"
    "toolbar.search": undefined, // In English: "Search"
    "toolbar.qrcode": undefined, // In English: "QR Code"
    "used_of": undefined, // In English: "{{used}} used of {{available}}"
    "worker": undefined, // In English: "Worker"
    "billing.offering.basic": undefined, // In English: "Basic"
    "too_many_attempts": undefined, // In English: "Too many attempts. Please try again later."
    "server_timeout": undefined, // In English: "The server took too long to respond. Please try again."
    "signup_error": undefined, // In English: "An error occurred during signup. Please try again."
    "welcome_title": undefined, // In English: "Welcome to your Personal Internet Computer"
    "welcome_description": undefined, // In English: "Store files, play games, find awesome apps, and much more! All in one place, accessible from anywhere at any time."
    "welcome_get_started": undefined, // In English: "Get Started"
    "welcome_terms": undefined, // In English: "Terms"
    "welcome_privacy": undefined, // In English: "Privacy"
    "welcome_developers": undefined, // In English: "Developers"
    "welcome_open_source": undefined, // In English: "Open Source"
    "welcome_instant_login_title": undefined, // In English: "Instant Login!"
    "alert_error_title": undefined, // In English: "Error!"
    "alert_warning_title": undefined, // In English: "Warning!"
    "alert_info_title": undefined, // In English: "Info"
    "alert_success_title": undefined, // In English: "Success!"
    "alert_confirm_title": undefined, // In English: "Are you sure?"
    "alert_yes": undefined, // In English: "Yes"
    "alert_no": undefined, // In English: "No"
    "alert_retry": undefined, // In English: "Retry"
    "alert_cancel": undefined, // In English: "Cancel"
    "signup_confirm_password": undefined, // In English: "Confirm Password"
    "login_email_username_required": undefined, // In English: "Email or username is required"
    "login_password_required": undefined, // In English: "Password is required"
    "window_title_open": undefined, // In English: "Open"
    "window_title_change_password": undefined, // In English: "Change Password"
    "window_title_select_font": undefined, // In English: "Select font…"
    "window_title_session_list": undefined, // In English: "Session List!"
    "window_title_set_new_password": undefined, // In English: "Set New Password"
    "window_title_instant_login": undefined, // In English: "Instant Login!"
    "window_title_publish_website": undefined, // In English: "Publish Website"
    "window_title_publish_worker": undefined, // In English: "Publish Worker"
    "window_title_authenticating": undefined, // In English: "Authenticating..."
    "window_title_refer_friend": undefined, // In English: "Refer a friend!"
    "desktop_show_desktop": undefined, // In English: "Show Desktop"
    "desktop_show_open_windows": undefined, // In English: "Show Open Windows"
    "desktop_exit_full_screen": undefined, // In English: "Exit Full Screen"
    "desktop_enter_full_screen": undefined, // In English: "Enter Full Screen"
    "desktop_position": undefined, // In English: "Position"
    "desktop_position_left": undefined, // In English: "Left"
    "desktop_position_bottom": undefined, // In English: "Bottom"
    "desktop_position_right": undefined, // In English: "Right"
    "item_shared_with_you": undefined, // In English: "A user has shared this item with you."
    "item_shared_by_you": undefined, // In English: "You have shared this item with at least one other user."
    "item_shortcut": undefined, // In English: "Shortcut"
    "item_associated_websites": undefined, // In English: "Associated website"
    "item_associated_websites_plural": undefined, // In English: "Associated websites"
    "no_suitable_apps_found": undefined, // In English: "No suitable apps found"
    "window_click_to_go_back": undefined, // In English: "Click to go back."
    "window_click_to_go_forward": undefined, // In English: "Click to go forward."
    "window_click_to_go_up": undefined, // In English: "Click to go one directory up."
    "window_title_public": undefined, // In English: "Public"
    "window_title_videos": undefined, // In English: "Videos"
    "window_title_pictures": undefined, // In English: "Pictures"
    "window_title_puter": undefined, // In English: "Puter"
    "window_folder_empty": undefined, // In English: "This folder is empty"
    "manage_your_subdomains": undefined, // In English: "Manage Your Subdomains"
    "open_containing_folder": undefined, // In English: "Open Containing Folder"

  },
};

export default ur;
